import { addOffsetTextToTimestamp, convertToZonedTimestamp } from "common/helpers/dateAndTimeHelpersV2";
import { months, daysInMonth } from "..";

export const generateCalendarMonth = (year: number, month: number, timeZone = 'UTC'): (string | null)[][] => {
  // month: 0-based (0 = January, 11 = December)
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const daysInMonth = lastDay.getDate();

  // 0 (Sun) -> 6, 1 (Mon) -> 0, ..., 6 (Sat) -> 5
  const getMondayStartIndex = (day: number) => (day + 6) % 7;

  const calendar: (string | null)[][] = [];
  let week: (string | null)[] = Array(7).fill(null);
  let dayOfWeek = getMondayStartIndex(firstDay.getDay());

  // Fill previous month's days in the first week
  if (dayOfWeek > 0) {
    // Get last day of previous month
    const prevMonthLastDay = new Date(year, month, 0).getDate();
    const prevMonth = month === 0 ? 11 : month - 1;
    const prevMonthYear = month === 0 ? year - 1 : year;
    for (let i = 0; i < dayOfWeek; i++) {
      const day = prevMonthLastDay - dayOfWeek + i + 1;
      week[i] = convertToZonedTimestamp(new Date(prevMonthYear, prevMonth, day, 0, 0, 0, 0), timeZone) as string;
    }
  }

  for (let day = 1; day <= daysInMonth; day++) {
    const date = new Date(year, month, day, 0, 0, 0, 0);
    week[dayOfWeek] = convertToZonedTimestamp(date, timeZone) as string;
    if (dayOfWeek === 6 || day === daysInMonth) {
      // Fill next month's days in the last week
      if (day === daysInMonth && dayOfWeek < 6) {
        const nextMonth = (month + 1) % 12;
        const nextMonthYear = month === 11 ? year + 1 : year;
        for (let i = dayOfWeek + 1; i < 7; i++) {
          week[i] = convertToZonedTimestamp(new Date(nextMonthYear, nextMonth, i - dayOfWeek, 0, 0, 0, 0), timeZone) as string;
        }
      }
      calendar.push(week);
      week = Array(7).fill(null);
    }
    dayOfWeek = (dayOfWeek + 1) % 7;
  }

  return calendar;
};



export const generateCalendarMonthWithTimeZone = (year: number, month: number, timeZone: string): string[] => {
  const useMonth = month + 1


  const startStamp = addOffsetTextToTimestamp(`${year}-${useMonth < 10 ? `0${useMonth}` : useMonth}-01T00:00:00`, { timeZone })
  const startTime = new Date(startStamp).getTime()
  
  const days = [startStamp] as string[]
  const maxDays = daysInMonth[month] || 30
 
  for (let i = 2; i < (maxDays + 1); i++) {
    const n = addOffsetTextToTimestamp(`${year}-${useMonth < 10 ? `0${useMonth}` : useMonth}-${i < 10 ? `0${i}` : i}T00:00:00`, { timeZone })
    days.push(n)
    
  }

  return days

}